<!-- Common header-->
<app-header></app-header>
<app-exclusive-top-slider></app-exclusive-top-slider>

<div class="middle-panel hidelg">
    <ul uk-tab class="swtitch-tab">
        <li class="uk-active"><a [routerLink]="['/'+this.selectedCity.toLowerCase()+'/exclusives']">Exclusive</a></li>
        <li><a [routerLink]="['/'+this.selectedCity.toLowerCase()+'/deals']">Deals</a></li>
    </ul>
</div>

<app-exclusive-categories></app-exclusive-categories>

<!--Scroll Top-->
<a class="scrollup" (click)="scrollToTop($event.target)"><span class="fa fa-angle-up"></span></a>
<app-footer></app-footer>
